module.exports = __webpack_public_path__ + "static/img/uxdesignmobile.25ae417.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/With/uxdesignmobile.png
// module id = Q+Tg
// module chunks = 0